import React from 'react';
import AppliedFilters, { AppliedFilterChip } from '../UI/AppliedFilters';

export function CatalogFilterSelect({
  label,
  value,
  onChange,
  children,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  children: React.ReactNode;
}) {
  return (
    <label className="block text-sm font-medium text-gray-700">
      {label}
      <select
        className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {children}
      </select>
    </label>
  );
}

export default function CatalogFilterLayout({
  children,
  results,
  applied,
  onClearFilters,
}: {
  children: React.ReactNode;
  results: React.ReactNode;
  applied?: AppliedFilterChip[];
  onClearFilters?: () => void;
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="mt-8 grid lg:grid-cols-[16rem_minmax(0,1fr)] gap-6 lg:gap-8 items-start">
      <aside className="lg:sticky lg:top-24 surface-card p-4">
        <button
          type="button"
          className="lg:hidden w-full flex items-center justify-between text-xs font-semibold uppercase tracking-wide text-gray-500"
          onClick={() => setOpen((value) => !value)}
        >
          Filters
          <span className="text-primary-700 normal-case tracking-normal font-semibold">{open ? 'Hide' : 'Show'}</span>
        </button>
        <p className="hidden lg:block text-xs font-semibold uppercase tracking-wide text-gray-500">Filters</p>
        <div className={`${open ? 'mt-4 space-y-4' : 'hidden'} lg:block lg:mt-4 lg:space-y-4`}>
          {children}
        </div>
      </aside>
      <div className="min-w-0">
        {applied?.length ? <AppliedFilters items={applied} onClear={onClearFilters} /> : null}
        {results}
      </div>
    </div>
  );
}
